import React from 'react';
import styles from './style.module.css';
import IframeResize from "../../../../common/components/iframe-resize";

export default () => (
    <div className={styles.page}>
        <h1 className={'invisible'}>TFSA vs. RRSP Calculator</h1>
        <iframe src="https://www.financialcalculators.net/librocu/tfsa-rrsp/" title="TFSA vs. RRSP Calculator" scrolling="no" frameBorder="0"> </iframe>
        <IframeResize/>
    </div>
);
